import MediaAdviserTypeEnum from '@constants/enums/media/adviser/type';
import MediaFormatEnum from '@constants/enums/media/format';
import MediaTypeEnum from '@constants/enums/media/type';

import MediaAdviserApi from '@packages/media/adviser/api';

import { Media, Adviser } from '@/models';

export class MediaAdviser extends Media {
    static name = 'MediaAdviser';
    static entity = 'mediaAdviser';
    static Api = MediaAdviserApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(MediaAdviserTypeEnum, MediaAdviserTypeEnum.FEES),
            library_type: this.string(MediaTypeEnum.ADVISER),
            format: this.enum(MediaFormatEnum, MediaFormatEnum.DOC),
            adviser_id: this.string(null).nullable(),
            adviser: this.belongsTo(Adviser, 'adviser_id')
        };
    }
}

export default MediaAdviser;
